import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=46a1c60c&scoped=true&"
import script from "./OrderStatistics.vue?vue&type=script&lang=js&"
export * from "./OrderStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a1c60c",
  null
  
)

export default component.exports